module.exports = __webpack_public_path__ + "img/bank4.1f0167f9.png";